import { render, staticRenderFns } from "./dui-pagination.vue?vue&type=template&id=a03cf454&"
import script from "./dui-pagination.vue?vue&type=script&lang=js&"
export * from "./dui-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports